import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Bonuses } from './components/Bonuses';
import { ComparisonTable } from './components/ComparisonTable';
import { Testimonials } from './components/Testimonials';
import { FinalOffer } from './components/FinalOffer';
import { Objections } from './components/Objections';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel } from './utils/metaPixel';
import { COURT_BG } from './data/content';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="relative min-h-full w-full overflow-hidden bg-[var(--pb-navy)]" data-id="element-0" data-mp="31brzvakwgrl4">
      {/* Blurred pickleball court background */}
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: `url(${COURT_BG})`
    }} data-id="element-1" data-mp="2whxb3sqftmf6" />
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0 bg-[#08111f]/95" data-id="element-2" data-mp="23v2tr4ox335x" />

      {/* Content */}
      <main className="landing-content relative z-10 mx-auto w-full max-w-lg" data-id="element-3" data-mp="3mlavz2zp87rv">
        <Hero data-id="element-4" data-mp="3mj6jvxrnc2gi" />
        <PainPoints data-id="element-5" data-mp="3rcj5s04xxv5k" />
        <Bonuses data-id="element-6" data-mp="3rbzomln47asl" />
        <ComparisonTable data-id="element-7" data-mp="3rdkgg3i1ofmr" />
        <Testimonials data-id="element-8" data-mp="3recdzjv7cnfo" />
        <FinalOffer data-id="element-9" data-mp="5yhgo69t1c8" />
        <Objections data-id="element-10" data-mp="67z9oh5w26u" />

        <footer className="px-5 pb-24 pt-4 text-center" data-id="element-11" data-mp="4n5w26l2pak">
          <p className="text-xs text-white/65" data-id="element-12" data-mp="2zld0746gb58w">
            © {new Date().getFullYear()} Pickleball Coach 360 · All rights
            reserved.
          </p>
        </footer>
      </main>

      <PurchasePopup data-id="element-13" data-mp="38lrnua6w0wfk" />
    </div>;
}